<div class="row g-0">
    @for (theme of themes().groups; track theme.name) {
    <div class="col col-auto text-center" [style]="{'width': `${100* theme.questions.length / themes().length}%`}"
        [ngClass]="{'is-active fw-bold': theme.name === activeTheme()}">
        <div class="line"></div>
        {{theme.name}}
    </div>

    }
</div>
